module.exports = __webpack_public_path__ + "static/media/graph.5e305ccb.png";